import { ENVIRONMENT } from '@/lib/config';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

const useGetLinkCheckPoint = () => {
  const { lang } = useTranslation();
  const router = useRouter();

  const getLinkCheckPoint = ({
    id,
    type,
    slug,
    skills,
    assignTestCode,
  }: {
    id: string;
    slug?: string;
    type: string;
    skills?: string[] | null;
    assignTestCode?: string;
  }) => {
    const typeCheckPoint = type?.toLowerCase();

    const isKetPet = ['ket', 'pet'].includes(slug?.toLowerCase() || '');

    if (typeCheckPoint?.includes('writing')) {
      const params = new URLSearchParams({});
      if (isKetPet) {
        params.set('scoring', 'AI');
      }
      if (assignTestCode) {
        params.set('assignTestCode', assignTestCode);
      }
      return `/write/${id}?${params.toString()}`;
    }
    if (typeCheckPoint?.includes('speaking')) {
      if (isKetPet) {
        return `/speaking-kp/checkpoint/${id}${
          assignTestCode ? `?assignTestCode=${assignTestCode}` : ''
        }`;
      }

      const params = new URLSearchParams({});
      params.set('url_back', window.location.href);
      params.set('assignTestCode', assignTestCode || '');
      return `${ENVIRONMENT.PUBLIC_SPEAKING_URL()}${
        lang ? `/${lang}` : ''
      }/checkpoint/${id}?${params.toString()}`;
    }

    if (typeCheckPoint?.includes('study')) {
      return `/lesson/${id}${assignTestCode ? `?assignTestCode=${assignTestCode}` : ''}`;
    }

    if (typeCheckPoint?.includes('practice')) {
      return `/practice/${id}?url_back=${router.asPath}${
        assignTestCode ? `&assignTestCode=${assignTestCode}` : ''
      }`;
    }

    if (typeCheckPoint?.includes('ielts')) {
      return `${ENVIRONMENT.IELTS_URL}${
        lang ? `/${lang}` : ''
      }/ielts/${skills?.[0]?.toLowerCase()}/${id}${
        assignTestCode ? `?assignTestCode=${assignTestCode}` : ''
      }`;
    }

    return `/check-point/${id}${assignTestCode ? `?assignTestCode=${assignTestCode}` : ''}`;
  };

  return { getLinkCheckPoint };
};

export default useGetLinkCheckPoint;
